export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 9.5a3 3 0 013 3V14h.5a2 2 0 012 2v4.5a2 2 0 01-2 2h-7a2 2 0 01-2-2V16a2 2 0 012-2h.5v-1.5a3 3 0 013-3zm-3.5 11h7V16h-7v4.5zm3.5-9a1 1 0 00-1 1V14h2v-1.5a1 1 0 00-1-1z\" fill=\"#7B61FF\"/><path d=\"M10 2.5a1 1 0 01.781.375L12.481 5H21l.102.005A1 1 0 0122 6v6h-2V7h-8a1 1 0 01-.781-.375L9.519 4.5H4v12h3.5v2H3a1 1 0 01-1-1v-14a1 1 0 011-1h7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};